import Script from 'next/script'
import { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

export const PricePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Share Price Information"
        subTitleText="株価情報"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <iframe
        id="irpocket-stock-chart-pc"
        src="//irpocket.com/stock-chart/141A.html"
        width="100%"
        height="920"
      ></iframe>
      <Script src="//irpocket.com/stock-chart/assets/javascript/141A/resize.js" />
    </Layout>
  )
}

PricePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主、投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock' },
    { name: '株価情報', path: '' },
  ]

  return (
    <>
      <Head
        title="株価情報"
        description="トライアルホールディングスの株価チャートを掲載しています。"
        ogp={{ url: 'ir/stock/price' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
